<style lang="scss">
  .p-button {
    max-width: 143px;
  }
</style>

<!-- eslint-disable -->
<template>
  <div class="d-flex justify-content-end">
    <b-button :class="{'disabled': loading}" v-if="!filters.sentForPrinting"
              @click="showModal('modal-print-warning')" class="btn full-width mr-1 p-button">Print All</b-button>
    <b-button :class="{'disabled': loading}" v-if="!filters.sentForPrinting"
              @click="showModal('modal-print-queue')" class="btn full-width mr-1 p-button">Print Queue History</b-button>

    <b-button :class="{'disabled': loading}" v-if="filters.status === 'Approved' && filters.sentForPrinting"
              @click="startReprint()" class="btn full-width mr-1 p-button">Print Results</b-button>
    <b-button v-if="printQueueUrl" @click="openFile(printQueueUrl)" class="btn-success full-width p-button">Open PDF</b-button>

    <b-modal id="modal-print-warning" title="" hide-footer>
      <warning-modal title="Are you sure you wish to print all?"
                     note="Once the post has been fetched for print, it will mark post as delivered,
       and re-running this operation will result in a different outcome"
                     @ok="fetchPrintQueue()"
                     @close="closeModals()"/>
    </b-modal>

    <b-modal id="modal-print-queue" title="" hide-footer size="lg">
      <print-queue-history></print-queue-history>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import PrintQueueHistory from '@/components/printQueue/PrintQueueHistory.vue';
  import PostService from '../../services/PostService';
  import WarningModal from '../modals/WarningModal.vue';

  export default {
    components: {
      WarningModal,
      PrintQueueHistory,
    },
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        printQueueUrl: '',
        results: [],
        currentPage: 1,
      };
    },
    computed: {
      ...mapState({
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
      }),
    },
    mounted() {},
    methods: {
      showModal(modalName) {
        this.$bvModal.show(modalName);
      },
      fetchPrintQueue() {
        this.loading = true;
        this.closeModals()

        PostService.getPrintQueue().then(res => {
          this.setUrlAndOpenFile(res.data.file_url);
          this.$emit('pdf-generated', true);
        }).catch(err => {
          let error = 'Could not get print queue, please refresh and try again';

          if (err.response && err.response.status === 400) {
            error = 'Print Queue is empty, nothing to print';
          }

          this.$toast.error(error, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      startReprint() {
        this.loading = true;
        this.currentPage = 1; // set the first page to one
        this.results = []; // reset array

        this.getResultsToPrint();
      },
      getResultsToPrint() {
        const newFilters = { ...this.filters };
        newFilters.limit = 50;
        newFilters.skip = (this.currentPage - 1) * newFilters.limit;

        PostService.getAll(newFilters).then(res => {
          this.results = this.results.concat(res.data.data); // keep adding since were stacking requests

          if (this.results.length < res.data.count) {
            this.getMoreResults();
          } else {
            this.printResults();
          }
        }).catch(err => {
          console.log('Error getting post ', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      getMoreResults() {
        this.currentPage += 1;
        this.getResultsToPrint();
      },
      printResults() {
        const reprintPostIds = this.results.map(post => post._id);

        PostService.reprintResults(reprintPostIds).then(res => {
          this.setUrlAndOpenFile(res.data.file_url);
          this.$emit('pdf-generated', true);
        }).catch(err => {
          let error = 'Could not get print queue, please refresh and try again';

          if (err.response && err.response.status === 400) {
            error = 'Print Queue is empty, nothing to print';
          }

          this.$toast.error(error, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      setUrlAndOpenFile(url) {
        this.printQueueUrl = url;
        this.openFile(url);
      },
      openFile(url) {
        window.open(url);
      },
      closeModals() {
        this.$bvModal.hide('modal-print-warning');
        this.$bvModal.hide('modal-print-queue');
      },
    },
  };
</script>
